import { render, staticRenderFns } from "./Zusatzangaben.vue?vue&type=template&id=63956114&"
import script from "./Zusatzangaben.vue?vue&type=script&lang=js&"
export * from "./Zusatzangaben.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports